export enum SortableMessageColumn {
    SENDER = 'sender',
    RECIPIENT = 'recipient',
    SENT_TIME = 'sentTime',
    SUBJECT = 'subject',
}
